import React from "react";
import isPropsEqual from "react-fast-compare";
import ButtonComponent, { ButtonProps } from "@mui/material/Button";

function Button(props: ButtonProps) {
  return <ButtonComponent {...props} />;
}

export default React.memo(Button, isPropsEqual);
